import { instance } from "./baseClient";

export const getTextResource = async (language = "en", file) => {
  return instance
    .get(`${language}/TextResources/${file ? `file/${file}` : ""}`)
    .then((response) => response.data);
};
